module.exports = __webpack_public_path__ + "img/game5.795e7775.png";